// Module
var code = "<div id=\"plugins\" ng-if=\"$ctrl.pluginsFetched\" ng-class=\"{ '{{$ctrl.accessPoint}}': true }\"><plugin ng-if=\"$ctrl.item\" ng-repeat=\"plugin in $ctrl.plugins\" plugin=\"plugin\" access-point=\"{{ $ctrl.accessPoint }}\" item=\"$ctrl.item\" context=\"{{ $ctrl.context }}\"></plugin></div>";
// Exports
module.exports = code;